import React from 'react';
import ReactDOM from 'react-dom';

import App from './App';
import { unregister } from './registerServiceWorker';

import './assets/styles/base.scss';

unregister();

ReactDOM.render(<App />, document.getElementById('root'));
